export class Constants {
  static APP_KEY = "com.gozmartch.gzre";
  static RING_AUDIO_KEY = "RING_AUDIO_KEY";
  static WALL_TABLET_MANUFACTURERS = ["Allwinner", "rockchip", "ZDMID"];
  static WALL_TABLET_MODELS = [
    "YF_XXXG",
    "rk312x",
    "APPC-10DSK",
    "APPC-7DSQPM",
    "APPC-7DSQ",
  ];
  static TYPE_ENDPOINTS = {
    BATTERY: "b",
    INTERNAL_TEMP: "t",
    POWER_SIGNAL: "l",
    POWER_CONPSUMPTION: "p",
    SWITCH_1: "sw1",
    SWITCH_2: "sw2",
    DIMMER: "d",
    SLIDE_DIMMER: "Dimmer",
    POWER_DIMMER: "POWER",
    COOLER: "co",
    FAN: "f",
    RELAY_0: "relay_0",
    RELAY_1: "relay_1",
    RELAY_2: "relay_2",
    RELAY_3: "relay_3",
    RELAY_4: "relay_4",
    RELAY_5: "relay_5",
    RELAY_6: "relay_6",
    RELAY_7: "relay_7",
    REMOTE_0: "relay_0",
    REMOTE_1: "relay_1",
    DOORSENSOR_0: "relay_2",
    DOORSENSOR_1: "relay_3",
    DOORSENSOR_2: "relay_4",
    DOORSENSOR_3: "relay_5",
    MOVEMENT_0: "relay_6",
    MOVEMENT_1: "relay_7",
    CLIMA_0: "relay_0",
    CLIMA_1: "relay_1",
    CLIMA_2: "relay_2",
    CLIMA_3: "relay_3",
    CLIMA_4: "relay_4",
    CLIMA_5: "relay_5",
    CLIMA_6: "relay_6",
    CLIMA_7: "relay_7",
    BRIGHTNESS: "bri",
    COLOR: "hue",
    SATURATION: "sat",
    ON: "on",
    DALI: "dali",
    DALI_ID: "value_",
    VERSION: "version",
    LOCATION: "location",
    RSSI: "rssi",
    UPTIME: "c",
    UPTIME2: "uptime",
    VCC: "vcc",
    IP: "ip",
    TEMPERATURE: "temperature",
    TARGET_TEMPERATURE: "display_targettemperature",
    FAN_SPEED: "fan_speed",
    ECO_MODE: "eco_mode",
    TEMPERATURE_MODE: "mode",
    TEMPERATURE_MANUAL_MODE: "manual_mode",
    TEMPERATURE_SYSTEM_MODE: "system_mode",
    STATUS_SWITCH: "status",
    HUMIDITY: "humidity",
    CO2: "co2",
    PRESSURE: "pressure",
    CT_TEMPERATURE: "ct",
    WORKING_MODE: "workingmode",
  };

  static TYPE_NODE = {
    THERMOSTAT: "000001",
    SMARTLIGHT_SWITCH: "000002",
    SMARTLIGHT_DIMMING: "000003",
    HEATING: "000004",
    SONOFF_SWITCH: "000005",
    DOOR_BELL: "000007",
    THERMOSTAT2: "0000010",
    INNER_LIGHT: "0000011",
    BLIND2: "000015",
    BLIND: "000017",
    SMART_BELL: "000020",
    SMART_BELL_LP: "000021",
    LIGHT: "000022",
    SENSOR: "000024",
    CLIMA: "000025",
    SMART_SIMPLE: "000027",
    SMART_BLIND: "000029",
    DISPLAY_WIFI: "000031",
    SMART_CLIMATE: "000040",
    SMART_CLIMATE_2: "000042",
    SMART_CLIMATE_3: "000071",
    SMART_MODBUS: "000051",
    TRUST_EXTENDED_LIGHT: "310002",
    SMART_4_CHANNEL: "000070",
    BUTTON: "000093",
    BUTTON_2: "000094",
  };
}



// WEBPACK FOOTER //
// ./src/providers/constants.ts